import { QueryClient } from '@tanstack/react-query';
import { ErroApi } from './api';

/** Não insistir em erro do cliente (4xx): 401/403/404/422 não melhoram com retry. */
export function deveRepetir(tentativas: number, erro: unknown): boolean {
  if (erro instanceof ErroApi && erro.statusCode >= 400 && erro.statusCode < 500) return false;
  return tentativas < 2;
}

export function criarQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: deveRepetir,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}
